<template>
  <div class="card p-3 mb-3 position-absolute w-100" style="z-index: 100;">
    <LoadingIndicator v-if="loading" centered />
    <div v-if="!loading">
      <ul class="list-group">
        <li class="list-group-item" v-if="suggestions.length">
          <b>Suggestions</b>
        </li>
        <li class="list-group-item"  v-for="item in suggestions"  :key="item.zip + item.city" @click="$emit('select', item)" style="cursor: pointer;">
          {{ item.city }}, {{ item.state }} {{ item.zip }}
        </li>
        <li v-if="!suggestions.length">>No Suggestions Available</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator'

const searchSuggestions = debounce(async (searchTerm, callback) => {
  callback(await ApiClient.locations.get({ params: { cdq: searchTerm } }));
}, 200);

export default {
  components: {
    LoadingIndicator
  },
  props: {
    city: {
      type: String,
      default: '',
    },
    zip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      suggestions: [],
      suggestionsCount: 10,
      loading: false,
    };
  },
  computed: {
    searchTerm() {
      return `${this.zip || ''},${this.city || ''}`.trim();
    }
  },
  methods: {
    handleSearch() {
      const term = this.searchTerm;
      if (term.length > 2) {
        this.loading = true;
        searchSuggestions(term, apiResponse => {
          this.suggestions = apiResponse.data.data.slice(0, this.suggestionsCount);
          this.loading = false;
        });
      } else {
        this.suggestions = [];
      }
    }
  },
  watch: {
    zip: {
      handler() {
        this.handleSearch();
      },
      immediate: true
    },
    city: {
      handler() {
        this.handleSearch();
      },
      immediate: true
    }
  }
};
</script>
